import React from 'react';
import cn from 'classnames';
import styles from './Link.module.css';

type LinkProps = {
  text: string;
  onClick?: VoidFunction;
  disabled?: boolean;
  className?: string;
};

const Link = (props: LinkProps) => (
  <a onClick={props.onClick} className={cn(styles.link, props.className)}>
    {props.text}
  </a>
);

export default Link;
